import { render } from "./HiringPartner.vue?vue&type=template&id=25d5612c&scoped=true"
import script from "./HiringPartner.vue?vue&type=script&lang=js"
export * from "./HiringPartner.vue?vue&type=script&lang=js"

import "./HiringPartner.vue?vue&type=style&index=0&id=25d5612c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d5612c"]])

export default __exports__